import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/login");
            return;
        }
        const session_id = m[1];
        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id });
                setUser(data);
                // Clear the hash and route based on onboarding state
                window.history.replaceState(null, "", window.location.pathname);
                if (data.needs_birth_data) navigate("/onboarding");
                else navigate("/dashboard");
            } catch (e) {
                setError(formatApiError(e.response?.data?.detail) || e.message);
                setTimeout(() => navigate("/login"), 2500);
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-sand-50">
            <div className="text-center" data-testid="auth-callback">
                <div className="sp-overline mb-2">Aligning the stars</div>
                <div className="font-serif text-3xl">Signing you in…</div>
                {error && <div className="mt-4 text-sm text-red-700" data-testid="auth-callback-error">{error}</div>}
            </div>
        </div>
    );
}
